import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SidebarStateService {

  private readonly storageKey = 'sidebarState';
  private isOpenSubject = new BehaviorSubject<boolean>(true);
  private isHovered = new BehaviorSubject<boolean>(false);

  isOpen$ = this.isOpenSubject?.asObservable();

  constructor() {
    const storedState = localStorage.getItem(this.storageKey);
    const initialState = storedState !== null ? JSON.parse(storedState) : true;
    this.isOpenSubject = new BehaviorSubject<boolean>(initialState);
    this.isOpen$ = this.isOpenSubject.asObservable();
  }

  setSidebarState(isOpen: boolean) {
    this.isOpenSubject.next(isOpen);
    localStorage.setItem(this.storageKey, JSON.stringify(isOpen));
  }

  toggleSidebar() {
    this.setSidebarState(!this.isOpenSubject.value);
    if (this.isOpenSubject.value) {
      this.setHovered(false);
    }
  }

  getSidebarOpenState(): boolean {
    return this.isOpenSubject.value;
  }

  getSidebarState(): boolean {
    return this.isOpenSubject.value || this.isHovered.value;
  }

  setHovered(state: boolean) {
    this.isHovered.next(state);
  }

  getHovered(): boolean {
    return this.isHovered.value;
  }
}
